module.exports = __webpack_public_path__ + "components/tide-header/static/icon-tide-datum-26aab829d05cdbc113951c958050d3e3.svg";